/** Freeze the relevant log with the visible failure, before later requests replace it. */
import {
  DEBUG_REPORT_MAX_DETAIL, DEBUG_REPORT_MAX_ENTRIES, DEBUG_REPORT_MAX_MESSAGE,
  DEBUG_REPORT_MAX_NOTE, DEBUG_REPORT_MAX_SOURCE,
} from "@kola/shared";
import type { DebugLogEntry } from "../../core/debug-log.js";

export function errorReportDraft(
  source: string, message: string, entries: readonly DebugLogEntry[], detail?: string,
): { note: string; entries: DebugLogEntry[] } {
  return {
    note: `${source}: ${message}`.slice(0, DEBUG_REPORT_MAX_NOTE),
    entries: [
      ...entries.slice(-(DEBUG_REPORT_MAX_ENTRIES - 1)).map((entry) => ({ ...entry })),
      {
        id: (entries.at(-1)?.id ?? 0) + 1,
        ts: Date.now(), level: "error", count: 1,
        source: source.slice(0, DEBUG_REPORT_MAX_SOURCE),
        message: message.slice(0, DEBUG_REPORT_MAX_MESSAGE),
        ...(detail === undefined ? {} : { detail: detail.slice(0, DEBUG_REPORT_MAX_DETAIL) }),
      },
    ],
  };
}
